import ApplicationAdapter from "./application";

export default class ReservedIpAdapter extends ApplicationAdapter {
  urlForCreateRecord(_, snapshot) {
    return `${this.apiBaseUri}/ip/take?projectkey=${snapshot.belongsTo("project").id}`;
  }

  urlForDeleteRecord(id, _, snapshot) {
    let serverId = snapshot.belongsTo("server")?.id;

    if (serverId) {
      return `${this.apiBaseUri}/ip/remove?ipaddress=${id}&release=yes`;
    }

    return `${this.apiBaseUri}/ip/release?ipaddress=${id}&projectkey=${snapshot.belongsTo("project").id}`;
  }

  async assignToServer(address, serverId) {
    let { response } = await this.ajax(`${this.apiBaseUri}/ip/add`, "POST", {
      data: { ipaddress: address, serverid: serverId },
    });

    this.store.push(this.store.normalize("reserved-ip", response.details));
  }

  async unassignFromServer(address, { release = false } = {}) {
    let { response } = await this.ajax(`${this.apiBaseUri}/ip/remove`, "POST", {
      data: { ipaddress: address, release: release ? "yes" : "no" },
    });

    this.store.push(this.store.normalize("reserved-ip", response.details));
  }

  async updateRecord(_store, _type, snapshot) {
    let projectKey = snapshot.belongsTo("project")?.id;
    let ipaddress = snapshot.attr("address");
    let changed = snapshot.changedAttributes();

    if (changed.ptr) {
      let [, ptr] = changed.ptr;
      let endpoint = ptr?.length ? "setptr" : "resetptr";
      return this.ajax(`${this.apiBaseUri}/ip/${endpoint}?projectkey=${projectKey}`, "POST", {
        data: { ipaddress, data: ptr ?? "" },
      });
    }
  }
}
